import { useUserStore } from '~/stores/user'
import type { Permission } from '~/types/v2/Access'
import { permissionScopeFor } from '~/utils/permissionGate'

/**
 * `useCan` for a workspace permission in the route's workspace and its
 * organisation, scoped the way `07.permission` scopes a page's permission.
 */
export function useCanInWorkspace(permission: MaybeRefOrGetter<Permission>) {
  const route = useRoute()
  const userStore = useUserStore()

  return useCan(permission, () =>
    permissionScopeFor(route.params, userStore.organizations),
  )
}
